import { render, staticRenderFns } from "./CreateExamForSchedule.vue?vue&type=template&id=63e01651&scoped=true"
import script from "./CreateExamForSchedule.vue?vue&type=script&lang=js"
export * from "./CreateExamForSchedule.vue?vue&type=script&lang=js"
import style0 from "./CreateExamForSchedule.vue?vue&type=style&index=0&id=63e01651&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e01651",
  null
  
)

export default component.exports